import { store } from '@/store/store';
import { pedido } from '@/shared/dtos/pedido';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';

@Module({
    namespaced: true,
    name: 'pedidoModule',
    store,
    dynamic: true
})
class pedidoModule extends VuexModule {
    public pedidos: pedido[] = [];
    public pedido: pedido = new pedido();

    @Action({ commit: 'onGetpedidos' })
    public async getpedidos(showLoading: boolean = false) {
        return await ssmHttpService.get(API.pedido, undefined, showLoading);
    }

    @Action({ commit: 'onGetpedido' })
    public async getpedido(id: any) {
        return await ssmHttpService.get(API.pedido + '/' + id);
    }
    @Action
    public async importarpedido(pedido: pedido) {
       return await ssmHttpService.post(API.pedido+ '/importar', pedido.toJson());
    }
    @Action
    public async guardarpedido(pedido: pedido) {
       return await ssmHttpService.post(API.pedido, pedido.toJson());
    }

    @Action
    public async modificarpedido(pedido: pedido) {
        return await ssmHttpService.put(API.pedido + '/' + pedido.id, pedido);
    }

    @Action
    public async eliminarpedido(pedido: pedido) {
       return await ssmHttpService.delete(API.pedido + '/' + pedido.id, null, false);
    }

    @Mutation
    public onGetpedidos(res: pedido[]) {
        this.pedidos = res ? res.map((x) => new pedido(x)) : []
    }

    @Mutation
    public onGetpedido(res: pedido) {
        this.pedido = new pedido(res);
    }

}
export default getModule(pedidoModule);